<template>
  <vs-table :data="data">
    <template slot="header">

        <vs-button @click="back()">
          <feather-icon icon="ArrowLeftIcon" svgClasses="h-4 w-4" />
          Regresar
        </vs-button>
        <h2 style="margin-left: 10px">{{ title }}</h2>

        <div class="con-input-search vs-table--search">
          <input
            class="input-search vs-table--search-input"
            type="text"
            v-model="text"
            @keypress.enter="search"
          />
          <vs-icon icon="search"></vs-icon>
        </div>
    </template>
    <template slot="thead">

      <vs-th>
        {{ $t('request_date') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('document') | capitalize }}
      </vs-th>
        <vs-th>
        {{ $t('client') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('start_date') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('end_date') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('status') | capitalize }}
      </vs-th>
      <!-- <vs-th>
        {{ $t('') | capitalize }}
      </vs-th> -->

      <th class="qb-sticky"></th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="i" v-for="(tr, i) in data">
        <vs-td style="width:10vw;">
          {{ data[i].request_date | upperCase }}
        </vs-td>
         <vs-td style="width:30vw;">
          {{ data[i].document_name | upperCase }}
        </vs-td>
         <vs-td style="width:20vw;">
          {{ data[i].ClientName | upperCase }}
        </vs-td>
        <vs-td>
          {{ data[i].start_date | upperCase }}
        </vs-td>
        <vs-td>
          {{ data[i].end_date | upperCase }}
        </vs-td>

        <vs-td>
          <vs-button
            :color="data[i].status_color"
            text-color="white"
            type="filled"
            size="small"
            disabled
          >
          {{ $t(data[i].status_name) | upperCase }}
          </vs-button>
        </vs-td>
        <vs-td>
          <RepseUploadFile
            @refresh="refresh"
            :request_id="data[i].request"
            v-if="data[i].status_id == 1"
          />
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import ActionIcon from '@/components/ActionIcon.vue'
import RepseUploadFile from './RepseUploadFile.vue'
// import RepseFileViewer from './RepseFileViewer.vue'
import vendor from '@/http/requests/vendor/index.js'

export default {
  components: {
    ActionIcon,
    RepseUploadFile,
  },
  data() {
    return {
      text: '',
      statusRequest: null,
    }
  },
  methods: {
    back: function () {
      this.$emit('back')
    },
    handleClickSort: function (e) {
      this.$emit('sort', e)
    },
    infiniteHandler: function (isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    uploadFile: function () {
      this.$emit('upload')
    },
    search: function () {
      this.$emit('search', this.text)
    },
    showFile: function () {
      this.$emit('showFile')
    },
    validate: function () {
      this.$emit('validate')
    },
    refresh: function () {
      this.$emit('refresh')
    },
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

      <style>
</style>
